var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderNav'),_vm._v(" "),_c('main',[_c('article',[_c('h1',[_vm._v(_vm._s(_vm.Title))]),_vm._v(" "),_c('section',{attrs:{"id":"app-1"}},[_c('h2',{staticClass:"section_h2"},[_vm._v("#app-1:"+_vm._s(_vm.routerTitle))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.message))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1ed25cb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/levup/routerLevup.vue
// module id = UcXd
// module chunks = 0